(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/set-suspension.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/set-suspension.js');
'use strict';

const logger = svs.spelpaus.logger;
const {
  useDispatch
} = ReactRedux;
const {
  setActiveSuspensions,
  setHistorySuspensions
} = svs.spelpaus.store.suspension.actions;
const {
  Form,
  ControlGroup,
  Select,
  Option
} = svs.ui.reactForm;
const Button = svs.ui.ReactButton;
const {
  SUSPENSION_PRODUCTS,
  SUSPENSION_PERIOD,
  CALL_STATUS
} = svs.spelpaus.constants;
const {
  getAvailableSuspensionPeriods,
  setNewSuspensionAsync
} = svs.spelpaus.pages.svsSuspension.SvsSuspensionHelper;
const {
  getActiveSuspensionsAsync,
  getHistorySuspensionsAsync
} = svs.spelpaus.pages.svsSuspension.SvsSuspensionService;
const {
  ApproveInformation
} = svs.spelpaus.pages.svsSuspension.components;

const SetSuspension = () => {
  const dispatch = useDispatch();
  const activeSuspensions = ReactRedux.useSelector(state => state.suspension.activeSuspensions || []);
  const [product, setProduct] = React.useState('0');
  const [isProductError, setIsProductError] = React.useState(false);
  const [period, setPeriod] = React.useState('0');
  const [isPeriodError, setIsPeriodError] = React.useState(false);
  const [availableSuspensionPeriods, setAvailableSuspensionPeriods] = React.useState([]);
  const onClickButton = async e => {
    logger.debug('SetSuspension - onClickButton');
    e && e.preventDefault();
    let isValid = true;
    if (!SUSPENSION_PRODUCTS.find(item => item.id === product)) {
      isValid = false;
      setIsProductError(true);
    }
    if (!SUSPENSION_PERIOD.find(item => item.id === period)) {
      isValid = false;
      setIsPeriodError(true);
    }
    if (isValid) {
      logger.debug('*** onSubmitHandler OK!');
      const {
        status,
        suspensions
      } = await setNewSuspensionAsync(product, Number(period));
      logger.debug('*** back from setNewSuspensionAsync status, suspensions:', status, suspensions);
      if (status === CALL_STATUS.SUCCESS) {
        setProduct('0');
        setPeriod('0');
        if (suspensions) {
          logger.debug('*** suspensions OK!, dispatch-ing', suspensions);
          dispatch(setActiveSuspensions(suspensions));
        } else {
          const active = await getActiveSuspensionsAsync();
          dispatch(setActiveSuspensions(active));
        }
        const history = await getHistorySuspensionsAsync();
        dispatch(setHistorySuspensions(history));
      }
    }
  };
  const handleOnChangeProduct = e => {
    var _e$target, _e$target2;
    setProduct((e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) || '0');
    setAvailableSuspensionPeriods(getAvailableSuspensionPeriods(activeSuspensions, e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value));
    setPeriod('0');
    setIsProductError(false);
    setIsPeriodError(false);
  };
  const handleOnChangePeriod = async e => {
    var _e$target3;
    setPeriod((e === null || e === void 0 || (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.value) || '0');
    setIsPeriodError(false);
  };
  return React.createElement(React.Fragment, null, React.createElement("p", {
    className: "align-left"
  }, "H\xE4r kan du ta en spelpaus. V\xE4lj vilka spel du vill pausa dig fr\xE5n och hur l\xE4nge. Du kan v\xE4lja att pausa dig fr\xE5n alla spel, endast lotter och KenoXpress eller endast Vegas. Observera att varken du sj\xE4lv eller Svenska Spel kan h\xE4va en spelpaus i f\xF6rtid."), React.createElement(Form, {
    className: "align-left"
  }, React.createElement(ControlGroup, {
    errorMessage: "Du m\xE5ste v\xE4lja vad du vill pausa dig ifr\xE5n",
    hasError: isProductError,
    v2: true
  }, React.createElement(Select, {
    id: "selectProduct",
    label: "Vad vill du pausa dig ifr\xE5n?",
    onChange: handleOnChangeProduct,
    v2: true,
    value: product
  }, React.createElement(Option, {
    disabled: true,
    value: "0"
  }), SUSPENSION_PRODUCTS.map(p => React.createElement(Option, {
    key: p.id,
    value: p.id
  }, p.name)))), React.createElement(ControlGroup, {
    errorMessage: "Du m\xE5ste v\xE4lja en period",
    hasError: isPeriodError,
    v2: true
  }, React.createElement(Select, {
    id: "selectPeriod",
    label: "Hur l\xE4nge vill du pausa dig?",
    onChange: handleOnChangePeriod,
    v2: true,
    value: period
  }, React.createElement(Option, {
    disabled: true,
    value: "0"
  }), availableSuspensionPeriods.map(p => React.createElement(Option, {
    disabled: p.disabled,
    key: p.id,
    value: p.id
  }, p.period)))), React.createElement(ApproveInformation, null), React.createElement("div", {
    className: "grid-container-inner gutter-xs-1"
  }, React.createElement(Button, {
    block: true,
    className: "margin-top-2 margin-bottom-3",
    "data-test-id": "selectButton",
    inverted: true,
    onClick: onClickButton
  }, "Pausa"))));
};
svs.spelpaus.pages.svsSuspension.components.SetSuspension = SetSuspension;

 })(window);